import { Entity } from '../../../../base/Entity'

import { type PersistedType } from '../../../../Foobara/Autocrud/Types/PersistedType/Ambiguous'

import { type DynamicCommand } from '../../../../Foobara/Commandforge/Types/DynamicCommand/Ambiguous'

export type DomainPrimaryKeyType = number
export const domainPrimaryKeyAttributeName: 'id' = 'id'
export interface DomainAttributesType {
  id: number
  persisted_types: PersistedType[]
  persisted_commands: DynamicCommand[]
  name?: string
  organization_name?: string | null
  full_name?: string
}

export class Domain<
  AttributesType extends DomainAttributesType = DomainAttributesType
> extends Entity<DomainPrimaryKeyType, AttributesType> {
  static readonly modelName: string = 'Domain'
  static readonly entityName: string = 'Domain'
  static readonly primaryKeyAttributeName: 'id' = 'id'

  get id (): DomainPrimaryKeyType {
    return this.primaryKey
  }

  get associationPropertyPaths (): string[][] { return [['persisted_types', '#']] }
  readonly hasAssociations: true = true

  get persisted_types (): AttributesType['persisted_types'] {
    return this.readAttribute('persisted_types')
  }

  get persisted_commands (): AttributesType['persisted_commands'] {
    return this.readAttribute('persisted_commands')
  }

  get name (): AttributesType['name'] {
    return this.readAttribute('name')
  }

  get organization_name (): AttributesType['organization_name'] {
    return this.readAttribute('organization_name')
  }

  get full_name (): AttributesType['full_name'] {
    return this.readAttribute('full_name')
  }
}
